import { TableWrapper, TableWrapperProps } from '../TableWrapper'; // Adjust the path as needed
import useTableStore from '@store/tableStore';
import { Person } from '@hooks/people/types';

// Define the SelectableTableWrapper component
export const SelectableTableWrapper = <T extends object>(props: TableWrapperProps<T>) => {
  const {
    data,
    query,
    currentPage = 1, // Default to page 1 if not provided
    setPageNumber,
    ...rest
  } = props;
  const {
    newlySelectedItems,
    setNewlySelectedItems,
    removeNewlySelectedItems,
    allSelectedItems,
    setAllSelectedItems,
    removeAllSelectedItems,
    defaultPreselectedItems,
    newlyUnselectedItems,
    setNewlyUnselectedItems,
    removeNewlyUnselectedItems,
    selectedCountPerPage,
    setSelectedCountPerPage,
  } = useTableStore();
    const handleSelect = (selected: Person | null, all?: boolean) => {
 
    // Handle "Select All" functionality
    if (all) {
      const pageItems = data.map(item => item.id);
      const isAllSelected = pageItems.every(id => allSelectedItems.includes(id));
      
  
      if (isAllSelected) {
        // Unselecting all items
        removeAllSelectedItems(pageItems);
        
        // For preselected items, add to newly unselected
        const preselectedPageItems = pageItems.filter(id => 
          defaultPreselectedItems.includes(id)
        );
        if (preselectedPageItems.length > 0) {
          setNewlyUnselectedItems(preselectedPageItems);
        }
        
        // For newly selected items, remove them
        const newlySelectedPageItems = pageItems.filter(id => 
          newlySelectedItems.includes(id)
        );
        if (newlySelectedPageItems.length > 0) {
          removeNewlySelectedItems(newlySelectedPageItems);
        }
        
        setSelectedCountPerPage(currentPage, 0);
      } else {
        // Selecting all items
        setAllSelectedItems(pageItems);
        
        // For preselected items that were unselected, remove from newly unselected
        const preselectedUnselectedItems = pageItems.filter(id => 
          defaultPreselectedItems.includes(id) && 
          newlyUnselectedItems.includes(id)
        );
        if (preselectedUnselectedItems.length > 0) {
          removeNewlyUnselectedItems(preselectedUnselectedItems);
        }
        
        // For non-preselected items, add to newly selected
        const nonPreselectedItems = pageItems.filter(id => 
          !defaultPreselectedItems.includes(id)
        );
        if (nonPreselectedItems.length > 0) {
          setNewlySelectedItems(nonPreselectedItems);
        }
        
        setSelectedCountPerPage(currentPage, pageItems.length);
      }
      return;
    }
  
    // Handle single item selection
    if (selected) {
      const isPreselected = defaultPreselectedItems.includes(selected.id);
      const isCurrentlySelected = allSelectedItems.includes(selected.id);
  
      // console.log('Single selection:', {
      //   id: selected.id,
      //   isPreselected,
      //   isCurrentlySelected
      // });
  
      if (isCurrentlySelected) {
        // Unselecting an item
        removeAllSelectedItems([selected.id]);
        
        if (isPreselected) {
          setNewlyUnselectedItems([selected.id]);
        } else {
          removeNewlySelectedItems([selected.id]);
        }
        
        setSelectedCountPerPage(currentPage, 
          (selectedCountPerPage[currentPage] || 0) - 1
        );
      } else {
        // Selecting an item
        setAllSelectedItems([selected.id]);
        
        if (isPreselected) {
          removeNewlyUnselectedItems([selected.id]);
        } else {
          setNewlySelectedItems([selected.id]);
        }
        
        setSelectedCountPerPage(currentPage, 
          (selectedCountPerPage[currentPage] || 0) + 1
        );
      }
    }
  };


  // Ensure required props are passed to TableWrapper
  return (
    <TableWrapper
      {...rest}
      data={data}
      query={query}
      currentPage={currentPage}
      setPageNumber={setPageNumber}
      handleSelect={handleSelect}
    />
  );


};
